var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCheckedWhite(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 11,
    viewBox: "0 0 15 11",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.7022 0.246536C15.0807 0.591967 15.1011 1.17202 14.7479 1.54213L5.99786 10.7088C5.82439 10.8905 5.58286 10.9956 5.32866 10.9999C5.07445 11.0041 4.82936 10.9073 4.64959 10.7315L0.274587 6.45374C-0.0915291 6.09576 -0.0915291 5.51536 0.274587 5.15738C0.640704 4.7994 1.2343 4.7994 1.60041 5.15738L5.28925 8.76424L13.3771 0.291212C13.7304 -0.0788931 14.3237 -0.098895 14.7022 0.246536Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheckedWhite);
export default __webpack_public_path__ + "static/media/checked_white.ac562648a5b08b5b9e8aa358d4f33ca5.svg";
export { ForwardRef as ReactComponent };